import React, { useContext } from "react";
import { TableContext } from "./WeightHistoryTable.jsx";

export const WeightHistoryTableHead = () => {
  const { headerGroups } = useContext(TableContext);

  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => (
            <th
              {...column.getHeaderProps()}
              style={{ display: "flex", justifyContent: "center" }}
            >
              {column.render("Header")}
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
